<template>
    <Layout>
        <template v-slot:title>
            This athlete has no video yet
        </template>
    </Layout>
</template>

<script>
    import Layout from '../../EmptyStateLayout.vue'
    import { Button } from '@sportsrecruits/playbook'

    export default {
        components: { Button, Layout },
    }
</script>